<template>
  <div id="container_main">
    <div class="chain-banner">
      <div class="container">
        <h3 class="chain-title">
          <span class="chain-flow-name">榆林市涉企不动产登记</span>
        </h3>
        <p class="chain-subtitle">申请时间：<small id="applyTime"></small></p>
      </div>
    </div>
    <!--    <div class="declare-banner container">
            <div class="er-con">
                <div class="er-b-title chain-title">二手房转移登记及水电气暖联动过户</div>
                <div class="er-b-info">
                    <span class="">申请时间：<time id="applyTime">2023-01-06</time></span>
                </div>
            </div>
        </div>-->
    <div class="chain-steps-wrapper container chain-container">
      <div class="chain-steps">
        <div class="chain-step chain-step-active" data-step="#noticePanel">
          <span class="chain-step-index">1</span>
          <span class="chain-step-label">申报须知</span>
        </div>
        <div class="chain-step" data-step="#baseFormPanel">
          <span class="chain-step-index">2</span>
          <span class="chain-step-label"> 基本信息</span>
        </div>
        <div class="chain-step" data-step="#businessFormPanel">
          <span class="chain-step-index">3</span>
          <span class="chain-step-label">业务表单</span>
        </div>
        <!--
          <div class="chain-step" data-step="#materialPanel">
            <span class="chain-step-index">4</span>
            <span class="chain-step-label"> 材料上传</span>
          </div>
          <div class="chain-step" data-step="#emsPanel">
            <span class="chain-step-index">5</span>
            <span class="chain-step-label"> 邮寄信息</span>
          </div>
         -->
        <div class="chain-step" data-step="#reportPanel">
          <span class="chain-step-index">4</span>
          <span class="chain-step-label">申报告知</span>
        </div>
      </div>
    </div>

    <div class="chain-apply-panel" id="noticePanel" style="display:block;">
      <div class="container chain-container chain-shadow">
        <div class="chain-agreement ">
          <h3 class="chain-agreement-title">申报须知</h3>
          <div class="chain-apply-agreement">
            <p>为营造诚实守信的信用环境，树立企业诚信守法经营形象，本人（单位）作出如下信用承诺：</p>
            <ul>
              <li>
                一、严格遵守国家法律、法规、规章和政策规定，依法从事生产经营活动，重信守诺，维护良好的企业信用记录，并主动接受政府、行业组织、社会公众、新闻舆论的监督，积极履行社会责任。
              </li>
              <li>
                二、本人（单位）提供给行政监管部门、司法部门及行业组织的所有资料均合法、真实、准确和有效，无任何伪造修改和虚假成分，对所提供资料的真实性负责。
              </li>
              <li>
                三、自觉约束本人（单位企业法人代表、董事、监事、高管）积极遵守国家法律法规，维护良好的个人信用记录。
              </li>
              <li>
                四、发生违法失信行为，依照有关法律、行政法规规定接受行政执法部门给予的行政处罚、约束和惩戒，并依法承担相应责任。
              </li>
              <li>
                五、申请人承诺：本人对供电、供水、供气、供暖单位的服务协议无异议，自愿承接电气水暖原户主相应的余额，承担未结清的费用。上述申请事项是本人真实意思表示，所提交申请材料真实、合法、有效，对告知事项知晓且无异议，自愿承担由此产生的一切法律责任。
              </li>
            </ul>
          </div>
        </div>
        <div class="chain-agreement-confirm">
          <label>
            <input type="checkbox" class="chain-agreement-checkbox" />
            我已阅读并确认上述须知
          </label>
        </div>
        <div class="chain-panel-control">
          <button class="btn wb-btn--control chain-step-btn" id="step1NextBtn" disabled @click="nextStep('notice')">下一步</button>
        </div>
      </div>
    </div>
    <el-form ref="jcxxFrom" :model="jcxxData"  :rules="jcxxRules" >
    <div class="chain-apply-panel" id="baseFormPanel" style="display: none;">
      <div class="container chain-container">
        <!-- 基本信息表单 -->
        <div id="personForm" class="chain-base-form">
          <div class="chain-part">
            <div class="chain-part-title">
              <h4>基本信息</h4>
            </div>
            <div class="chain-part-content">
              <div data-v-3774b859="" class="step-body">
                <ul data-v-3774b859="" class="raido-group">
                  <li data-v-3774b859="">
                    <div data-v-3774b859="" class="radio-title">
                      <strong data-v-3774b859="" class="text-red">*</strong>
                      请选择交易类型
                    </div>
                    <div data-v-3774b859="" role="radiogroup" class="el-radio-group">
                      <el-form-item prop="jylx" >
                      <el-radio-group v-model="jcxxData.jylx" >
                          <el-radio label="mm">买卖</el-radio>
                      </el-radio-group>
                      </el-form-item>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label"><span class="required">*</span>企业名称</label>
                <div class="col-sm-6">
                  <el-form-item prop="xm" >
                    <el-input v-model="jcxxData.qymc"  placeholder="请输入企业名称" style="height:34px;"  readonly="true" ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label"><span class="required">*</span>统一社会信用代码</label>
                <div class="col-sm-6">
                  <el-form-item prop="xm" >
                    <el-input v-model="jcxxData.tyshxydm"  placeholder="请输入统一社会信用代码" style="height:34px;"  readonly="true" ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label"><span class="required">*</span>法代表人姓名</label>
                <div class="col-sm-6">
                  <el-form-item prop="xm" >
                    <el-input v-model="jcxxData.xm"  placeholder="请输入法代表人姓名" style="height:34px;"  readonly="true" ></el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label"><span class="required">*</span>联系电话</label>
                <div class="col-sm-6">
                  <el-form-item prop="lxdh" >
                    <el-input v-model="jcxxData.lxdh"  placeholder="请输入联系电话" style="height:34px;"  readonly="true"></el-input>
                  </el-form-item>
                  <small class="form-text text-muted"></small>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label"><span class="required">*</span>证件类型</label>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-4">
                      <select class="form-control" name="certType">
                        <option value="10">身份证</option>
                      </select>
                      <small class="form-text text-muted"></small>
                    </div>
                    <div class="col-sm-8">
                      <el-form-item prop="zjhm" >
                        <el-input v-model="jcxxData.zjhm"  placeholder="请输入证件号码" style="height:34px;"  readonly="true"></el-input>
                      </el-form-item>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label"><span class="required">*</span>地址</label>
                <div class="col-sm-6">
                  <el-form-item prop="dzxx" >
                    <el-input v-model="jcxxData.dzxx"  placeholder="请输入地址" style="height:34px;"></el-input>
                  </el-form-item>
                  <small class="form-text text-muted"></small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chain-panel-control">
          <button class="btn wb-btn--control chain-step-btn" id="baseFormPrevBtn"  @click="prevStep('notice')" >上一步</button>
          <el-button class="btn wb-btn--control chain-step-btn" id="baseFormNextBtn"  @click="nextStep('business')">下一步</el-button>
        </div>
      </div>
    </div>
    </el-form>
   <!-- ywbdFrom-->
    <el-form  ref="ywbdFrom" :model="formData" :rules="ywbdRules" >
    <div class="chain-apply-panel" id="businessFormPanel" style="display: none;">
      <div class="container chain-container">
        <div class="chain-business-form" style="height:700px;">
          <div class="drive-info" style="">
            <div data-v-3774b859="" class="step-body" style="">
              <div data-v-3774b859="" class="step-panel">
                <h4 data-v-3774b859="" class="step-content-title">
                  <i data-v-3774b859="" class="nc-icon nc-icon-glyph files_single-content-03"></i>
                  <span data-v-3774b859="">交易信息</span>
                </h4>
                <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label  class="el-form-item__label" style="width: 140px;"><span class="required">*</span>合同编号</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="htbh" >
                          <el-input v-model="formData.htbh"  placeholder="请输入合同编号"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label  class="el-form-item__label" style="width: 140px;"><span class="required">*</span>申报价格（元）</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="sbjg" >
                          <el-input v-model="formData.sbjg"  placeholder="请输入申报价格（元）"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>成交价格（元）</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                          <el-form-item prop="cjjg" >
                            <el-input v-model="formData.cjjg"  placeholder="请输入成交价格（元）"></el-input>
                          </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>成交日期</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="cjrq" >
                          <el-date-picker
                            v-model="formData.cjrq"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请输入成交日期"></el-date-picker>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>交房日期</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="jfrq" >
                          <el-date-picker
                            v-model="formData.jfrq"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="请输入交房日期"></el-date-picker>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>付款方式</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="fkfs" >
                            <el-select  v-model="formData.fkfs" clearable  placeholder="请选择付款方式" >
                              <el-option label="现金" value="XJ"></el-option>
                              <el-option label="转账" value="zz"></el-option>
                            </el-select>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>是否进行资金监管</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="sfzjjg" >
                          <el-select  v-model="formData.sfzjjg" clearable  placeholder="请选择是否进行资金监管" >
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>房屋坐落</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="fwzl" >
                          <el-input v-model="formData.fwzl"  placeholder="请输入房屋坐落"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width:33.3%;">
                    <div data-v-3774b859="" class="el-form-item">
                      <label class="el-form-item__label" style="width: 140px;"><span class="required">*</span>不动产权证号</label>
                      <div class="el-form-item__content" style="margin-left: 140px;">
                        <el-form-item prop="bdcqzh" >
                          <el-input v-model="formData.bdcqzh"  placeholder="请输入不动产权证号"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4 data-v-3774b859="" class="step-content-title" style="color: #719d79;font-size: 18px;">
            <i data-v-3774b859="" class="nc-icon nc-icon-glyph files_single-content-03"></i>
            <span data-v-3774b859="">出让方信息</span>
          </h4>
          <div data-v-3774b859="">
            <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
              <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width: 33.3%;">
                <div data-v-3774b859="" class="el-form-item is-required">
                  <label  class="el-form-item__label" style="width: 140px;">出让方(义务人)</label>
                  <div class="el-form-item__content" style="margin-left: 140px;">
                    <el-form-item prop="crf_xm" >
                      <el-input v-model="formData.crf_xm"  placeholder="请输入出让方(义务人)"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
              </div>
              <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width: 33.3%;">
                <div data-v-3774b859="" class="el-form-item is-required">
                  <label  class="el-form-item__label" style="width: 140px;">联系电话</label>
                  <div class="el-form-item__content" style="margin-left: 140px;">
                    <el-form-item prop="crf_lxdh" >
                      <el-input v-model="formData.crf_lxdh"  placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width: 33.3%;">
                <div data-v-3774b859="" class="el-form-item is-required">
                  <label  class="el-form-item__label" style="width: 140px;">证件号码</label>
                  <div class="el-form-item__content" style="margin-left: 140px;">
                    <el-form-item prop="crf_zjhm" >
                      <el-input v-model="formData.crf_zjhm"  placeholder="请输入证件号码"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
              </div>
              <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;">
              </div>
            </div>
          </div>
          <h4 data-v-3774b859="" class="step-content-title" style="color: #719d79;font-size: 18px;">
            <i data-v-3774b859="" class="nc-icon nc-icon-glyph files_single-content-03"></i>
            <span data-v-3774b859="">受让方信息</span>
          </h4>
          <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width: 33.3%;">
              <div data-v-3774b859="" class="el-form-item is-required">
                <label  class="el-form-item__label" style="width: 140px;">受让方(权利人)</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                  <el-form-item prop="srf_xm" >
                    <el-input v-model="formData.srf_xm"  placeholder="请输入受让方(权利人)"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width: 33.3%;">
              <div data-v-3774b859="" class="el-form-item is-required">
                <label  class="el-form-item__label" style="width: 140px;">联系电话</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                  <el-form-item prop="srf_lxdh" >
                    <el-input v-model="formData.srf_lxdh"  placeholder="请输入联系电话"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px; width: 33.3%;">
              <div data-v-3774b859="" class="el-form-item is-required">
                <label class="el-form-item__label" style="width: 140px;">证件号码</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                  <el-form-item prop="srf_zjhm" >
                    <el-input v-model="formData.srf_zjhm"  placeholder="请输入证件号码"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <h4 data-v-3774b859="" class="step-content-title" style="color: #719d79;font-size: 18px;">
            <i data-v-3774b859="" class="nc-icon nc-icon-glyph files_single-content-03"></i>
            <span data-v-3774b859="">选办事项</span>
          </h4>
          <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 140px;">是否办理电力过户</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                    <el-form-item prop="dlSfbl" >
                      <el-radio-group v-model="formData.dlSfbl" >
                        <el-radio label="1">是</el-radio>
                        <el-radio label="0">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">供应单位名称</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="dlGydwmc">
                    <el-input v-model="formData.dlGydwmc"  placeholder="请输入供应单位名称"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">户主</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="dlHz">
                    <el-input v-model="formData.dlHz"  placeholder="请输入户主"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">用电户号</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="dlYdhh">
                    <el-input v-model="formData.dlYdhh"  placeholder="请输入用电户号"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 140px;">是否办理自来水过户</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                    <el-form-item prop="shSfbl" >
                        <el-radio-group v-model="formData.shSfbl" >
                          <el-radio label="1">是</el-radio>
                          <el-radio label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">供应单位名称</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="shGydwmc">
                    <el-input v-model="formData.shGydwmc"  placeholder="请输入供应单位名称"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">户主</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="shHz">
                    <el-input v-model="formData.shHz"  placeholder="请输入户主"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">用电户号</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="shYshh">
                    <el-input v-model="formData.shYshh"  placeholder="请输入用水户号"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 140px;">是否办理天然气过户</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                  <el-form-item prop="trqSfbl" >
                    <el-radio-group v-model="formData.trqSfbl" >
                      <el-radio label="1">是</el-radio>
                      <el-radio label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">供应单位名称</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="trqGydwmc">
                    <el-input v-model="formData.trqGydwmc"  placeholder="请输入供应单位名称"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">户主</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="trqHz">
                    <el-input v-model="formData.trqHz"  placeholder="请输入户主"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">燃气编号</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="trqRqbh">
                    <el-input v-model="formData.trqRqbh"  placeholder="请输入燃气编号"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div data-v-3774b859="" class="el-row" style="margin-left: -10px; margin-right: -10px;">
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 140px;">是否办理暖气过户</label>
                <div class="el-form-item__content" style="margin-left: 140px;">
                  <el-form-item prop="nqSfbl" >
                    <el-radio-group v-model="formData.nqSfbl" >
                      <el-radio label="1">是</el-radio>
                      <el-radio label="0">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">供应单位名称</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="nqGydwmc">
                    <el-input v-model="formData.nqGydwmc"  placeholder="请输入供应单位名称"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">户主</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="nqHz">
                    <el-input v-model="formData.nqHz"  placeholder="请输入户主"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div data-v-3774b859="" class="el-col el-col-12" style="padding-left: 10px; padding-right: 10px;width: 25%;">
              <div data-v-3774b859="" class="el-form-item">
                <label class="el-form-item__label" style="width: 100px;">暖气编号</label>
                <div class="el-form-item__content" style="margin-left: 100px;">
                  <el-form-item prop="nqNqbh">
                    <el-input v-model="formData.nqNqbh"  placeholder="请输入暖气编号"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </div>

          <div class="chain-panel-control">
            <button class="btn wb-btn--control chain-step-btn" id="businessFormPrevBtn" @click="prevStep('business')">上一步</button>
            <el-button class="btn wb-btn--control chain-step-btn" id="businessFormNextBtn"  @click="nextStep('submit')">下一步</el-button>
          </div>
        </div>
      </div>
    </div>
    </el-form>
    <!-- 申报告知 -->
    <div class="chain-apply-panel" id="reportPanel" style="display: none;">
      <div class="container chain-container" id="printContainer">
        <div class="chain-apply-result-banner">
          <div class="text-center chain-apply-success">
            <h2 >提交成功！</h2>
            <div style="font-size: 16px;">
              <p>
                您于<span class="receive-time" id="receiveTimeId"></span>
                联合申报的事项已提交处理，申办流水号为：
                <span class="receive-number">&nbsp;{{ywlsh}}&nbsp;</span>
              </p>
              <p>我们将根据政策要求进行受理。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer hidden-sm hidden-md">
      <div class="container pure-g f5">
        <div class="u-1 u-md-1-4">
        </div>
        <div class="u-1 u-md-1-2">
          <div class="txt-ba">
            <p>
              <span>邮政编码：719000</span>
              <span>邮箱：zyghjjjz@163.com</span>
            </p>
            <p>
              <span>榆林市自然资源和规划局主办  电话：0912-3592615</span>
              <span>地址：榆林市高新区明珠大道天源路63号</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {ajaxPost} from '../../util/AjaxhttpRequest'
    import $ from 'jquery'
    import {BASE_URL} from '../../api/url'
    import API from '../../api/ApiConfig'
    export default {
        name: "ZydjLegalMain",
        components: {
        },
        data() {
            return {
                token:"",
                ywlsh:"",
                jcxxData:{
                    qymc:"",
                    tyshxydm:"",
                    xm:"",
                    lxdh:"",
                    zjlx:"sfz",
                    zjhm:"",
                    dzxx:"",
                    jylx:""
                },
                formData:{
                    ywlx:2,
                    qymc:"",
                    tyshxydm:"",
                    xm:"",
                    lxdh:"",
                    zjlx:"sfz",
                    zjhm:"",
                    dzxx:"",
                    jylx:"",
                    htbh:"",
                    sbjg:"",
                    cjjg:"",
                    cjrq:"",
                    jfrq:"",
                    fkfs:"",
                    sfzjjg:"",
                    fwzl:"",
                    bdcqzh:"",
                    dlSfbl:"",
                    dlGydwmc:"",
                    dlHz:"",
                    dlYdhh:"",
                    shSfbl:"",
                    shGydwmc:"",
                    shHz:"",
                    shYshh:"",
                    trqSfbl:"",
                    trqGydwmc:"",
                    trqHz:"",
                    trqRqbh:"",
                    nqSfbl:"",
                    nqGydwmc:"",
                    nqHz:"",
                    nqNqbh:"",
                    crf_xm:"",
                    crf_lxdh:"",
                    crf_zjhm:"",
                    srf_xm:"",
                    srf_lxdh:"",
                    srf_zjhm:""
                },
                crfxx: [],
                srfxx: [],
                jcxxRules: {
                    qymc:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    tyshxydm:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    xm:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    lxdh:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,required: true,message: "请输入合法联系电话",trigger: "blur"}
                    ],
                    zjhm:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,required: true,message: "请输入合法身份证号码",trigger: "blur"}
                    ],
                    dzxx:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    jylx:[{required: true, message: '请选择交易类型', trigger: 'blur'}]
                },
                ywbdRules:{
                    htbh:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    sbjg:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /(^\+?|^\d?)\d*\.?\d+$/,required: true,message: "请输入合法申报价格",trigger: "blur"}
                    ],
                    cjjg:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /(^\+?|^\d?)\d*\.?\d+$/,required: true,message: "请输入合法成交价格",trigger: "blur"}
                    ],
                    cjrq:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    jfrq:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    fkfs:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    sfzjjg:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    fwzl:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    bdcqzh:[{required: true, message: '当前值不能为空', trigger: 'blur'}],

                    crf_xm:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    crf_lxdh:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,required: true,message: "请输入合法联系电话",trigger: "blur"}
                    ],
                    crf_zjhm:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,required: true,message: "请输入合法身份证号码",trigger: "blur"}
                    ],
                    srf_xm:[{required: true, message: '当前值不能为空', trigger: 'blur'}],
                    srf_lxdh:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,required: true,message: "请输入合法联系电话",trigger: "blur"}
                    ],
                    srf_zjhm:[
                        {required: true, message: '当前值不能为空', trigger: 'blur'},
                        {pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,required: true,message: "请输入合法身份证号码",trigger: "blur"}
                    ],
                    dlSfbl:[{required: true, message: '请选择是否办理电力过户', trigger: 'blur'}],
                    shSfbl:[{required: true, message: '请选择是否办理自来水过户', trigger: 'blur'}],
                    trqSfbl:[{required: true, message: '请选择是否办理天然气过户', trigger: 'blur'}],
                    nqSfbl:[{required: true, message: '请选择是否办理暖气过户', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.init();
        },
        watch:{
        },
        methods: {
            init() {
                // 默认复选框不选中
                $('.chain-agreement-checkbox').prop('checked', false);
                this.bindEvent();
                this.verificationLogin();
                // 获得当前申请时间
                var mydate = new Date();
                var str = "" + mydate.getFullYear() + "年";
                str += (mydate.getMonth()+1) + "月";
                str += mydate.getDate() + "日";
                $('#applyTime').text(str);
                $('#receiveTimeId').text(str);
            },bindEvent() {
                // 申报须知复选框事件
                $('.chain-agreement-checkbox').change(function () {
                    var $nextBtn = $('#step1NextBtn');
                    if ($(this).prop('checked')) {
                        $nextBtn.removeAttr('disabled')
                    } else {
                        $nextBtn.attr('disabled', true)
                    }
                })
            },nextStep(flag) {        //下一步事件
                if (flag=='notice') { // 申报须知下一步,展示基本表单
                    $('#noticePanel').hide();
                    $('#baseFormPanel').show();
                    this.updateApplyProgress('baseFormPanel');  //展示基本表单
                } else if(flag=='business') {     //基本表单下一步,展示业务表单
                    this.$refs['jcxxFrom'].validate(valid => {
                        if (!valid) {
                            this.$message.warning("请检查【基础信息】填写");
                            return;
                        }
                        // 展示基本表单
                        $('#baseFormPanel').hide();
                        $('#businessFormPanel').show();
                        this.updateApplyProgress('businessFormPanel');
                    })
/*
                    $('#baseFormPanel').hide();
                    $('#businessFormPanel').show();
                    this.updateApplyProgress('businessFormPanel');*/
                } else if(flag=='submit') { //业务表单下一步,进行提交表单业务
                    this.$refs['ywbdFrom'].validate(valid => {
                        if (!valid) {
                            this.$message.warning("请检查【业务表单】信息");
                            return;
                        }
                        this.formData.qymc = this.jcxxData.qymc;
                        this.formData.tyshxydm = this.jcxxData.tyshxydm;
                        this.formData.xm = this.jcxxData.xm;
                        this.formData.lxdh= this.jcxxData.lxdh
                        this.formData.zjlx= this.jcxxData.zjlx
                        this.formData.zjhm= this.jcxxData.zjhm
                        this.formData.dzxx= this.jcxxData.dzxx
                        this.formData.jylx= this.jcxxData.jylx
                        var crxxArr = [];
                        var crxxObj = {
                            xm: this.formData.crf_xm,
                            lxdh: this.formData.crf_lxdh,
                            zjhm: this.formData.crf_zjhm,
                            lx: 1
                        }
                        var srxxObj = {
                            xm: this.formData.srf_xm,
                            lxdh: this.formData.srf_lxdh,
                            zjhm: this.formData.srf_zjhm,
                            lx: 2
                        }
                        crxxArr.push(crxxObj);
                        crxxArr.push(srxxObj);
                        var submitObj = {
                            jcxx: this.formData,
                            crxx: crxxArr
                        };
                        var parm =[]
                        parm.push(JSON.stringify(this.formData));
                        parm.push(JSON.stringify(crxxArr));
                        ajaxPost(API.ZydjProvider, "addZydj",parm).then((res) => {
                            debugger
                            //this.$message.success('保存成功!');
                            this.ywlsh = res;  // 返回业务申办流水号
                            $('#businessFormPanel').hide();
                            $('#reportPanel').show();
                            this.updateApplyProgress('reportPanel');
                        }).catch((err) => {
                            this.$message.error(err);
                        })
                    })
                }
            },prevStep(flag) {         // 上一步事件
                if (flag=='notice') {  // 基本表单上一步展示申报须知
                    $('#baseFormPanel').hide();
                    $('#noticePanel').show();
                    this.updateApplyProgress('noticePanel');
                } else if(flag=='business') { //业务表单上一步
                    $('#businessFormPanel').hide();
                    $('#baseFormPanel').show();  // 展示基本表单
                    this.updateApplyProgress('baseFormPanel');
                }
            },updateApplyProgress(name) {  // 修改申报进度
                var activePanel = '.chain-step[data-step="#'+ name +'"]';
                $(activePanel).addClass('chain-step-active').children('.chain-step-label').text()
            },verificationLogin() {
                var self = this;
                var url = window.location.href;
                if (url.length <55) {
                    window.location.href = "https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?authCheck=true&needAuth=true&client_id=SN000000710&redirect_uri=" + window.location.href;
                } else {
                    var urlPara = url.split("&");
                    var urlParaValue = urlPara[1].split("=");
                    var state = urlParaValue[1];
                    if (state=='false') { //陕西政务网未登录
                         window.location.href ="https://sfrz.shaanxi.gov.cn/#/login?client_name=null&response_type=code&client_id=SN000000710&redirect_uri="+encodeURIComponent(API.zydjLegalUrl);  //跳转至省平台登录界面
                    } else {// 陕西政务网已经登录,进行查询用户信息
                        if (url.indexOf("code")!=-1) {
                              var codeStr = urlPara[0];
                              var code = codeStr.substr(codeStr.indexOf("code")+5, codeStr.length);
                              var parm =[]
                              parm.push(code);
                              ajaxPost(API.ZydjProvider, "getLegalPerson",parm).then((res) => {
                                  let result = JSON.parse(res);
                                  self.jcxxData.qymc = result.userInfo.corpName;
                                  self.jcxxData.tyshxydm = result.userInfo.certificateSno;
                                  self.jcxxData.zjhm = result.userInfo.legalCertno;
                                  self.jcxxData.xm = result.userInfo.legalName;
                                  self.jcxxData.lxdh = result.userInfo.userMobile;
                              }).catch((err) => {
                                  this.$message.error(err);
                                  window.location.href ="https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?response_type=code&client_id=SN000000710&redirect_uri="+encodeURIComponent(API.zydjLegalUrl);  //获取省平台获取授权码
                              })
                        } else {
                              window.location.href ="https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?response_type=code&client_id=SN000000710&redirect_uri="+encodeURIComponent(API.zydjLegalUrl);  //获取省平台获取授权码
                        }
                    }
                }
            }
        }
    }
</script>
<style scoped>
  @import '../../assets/zydj/css/bootstrap.min.css';
  @import '../../assets/zydj/css/layui.css';
  @import '../../assets/zydj/css/common.css';
  @import '../../assets/zydj/css/global.css';
  @import '../../assets/zydj/css/chain.css';
  @import '../../assets/zydj/css/form.css';
  .declare-banner{
    height:150px;
    color: #fff;
    background: url('../../assets/zydj/img/dec-banner.png') no-repeat center;
  }
  .er-con{
    width: 1100px;
    margin: 0 auto;
    overflow: hidden;
  }
  .declare-banner .er-b-title	{
    font-size: 30px;
    line-height: 80px;
    min-height: 80px;
    font-weight: 600;
    letter-spacing:2px;
    margin-top: 10px;
  }
  .declare-banner .er-b-info{
    font-size: 14px;
    display: flex;
  }
  .declare-banner .er-b-info span{ margin-right: 25px;}

  .chain-banner {
    position: relative;
    height: 210px;
    background: url('../../assets/zydj/img/bannner.f8adbac.png') no-repeat;
    background-size: cover;
    background-color: #0081e3;
    margin-bottom: 10px;
    background-position: center;
  }
  .container {
    width: 1170px;
  }
  .chain-banner .chain-title {
    font-size: 30px;
    color:#ffffff;
    margin-top: 70px;
  }
  .chain-banner .chain-subtitle {
    font-size: 20px;
    color: #ffffff;
    margin-top: 20px;
  }

  <!-- 申报进度条 -->
  /* 步骤条 */
  .chain-steps {
    display: table;
  }

  .chain-step {
    display: table-cell;
    width: 1%;
    padding: 10px;
    position: relative;
  }
  .chain-step span {
    display: block;
    text-align: center;
  }
  .chain-steps-wrapper {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .chain-step-index {
    position: relative;
    z-index: 9;
    font-size: 18px;
    width: 46px;
    height: 46px;
    line-height: 46px;
    color: #888;
    border-radius: 50%;
    background: #e4e4e4;
    margin: 0 auto;
  }
  .chain-step-label {
    margin-top: 10px;
  }
  .chain-step-active>.chain-step-index {
    color: #FFF;
    background: #649F76;;
  }
  .chain-step-active>.chain-step-label {
    color: #649F76;;
  }

  .chain-step:before,
  .chain-step:after {
    content: '';
    position: absolute;
    top: 32px;
    width: 50%;
    height: 1px;
    background: #eee;
    z-index: 8;
  }
  .chain-step:before {
    left: 0;
  }

  .chain-step:after {
    right: 0;
  }
  .chain-step:first-child::before {
    height: 0;
  }
  .chain-step:last-child::after {
    height: 0;
  }
  .chain-step.chain-step-active::before,
  .chain-step.chain-step-active::after {
    background: #649F76;
  }

  <!--  申报告知-->
        .chain-agreement-title {
          text-align: center;
          font-weight: 700;
          margin: 20px 0 30px;
        }
  .chain-shadow {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }
  .chain-agreement {
    padding: 40px;
    list-style: none;
  }
  .chain-apply-agreement p ,
  .chain-agreement li{
    font-size: 16px;
    line-height: 1.5;
    margin-top: 10px;
  }
  .chain-agreement-confirm {
    margin-top: 10px;
    padding: 10px;
  }
  .chain-agreement-confirm label {
    margin: 0;
    -webkit-user-select: none;
    user-select: none;
  }
  .chain-agreement-checkbox {
    vertical-align: middle;
    margin: 0 !important;
  }
  <!-- 申报告知 -->
  .chain-result-tools {
    margin: 40px auto;
  }
  .chain-progress-QRCode {
    width: 100%;
  }

  .footer .txt-ba {
    font-size: 14px;
    color: #666;
    line-height: 30px;
    text-align: center;
    margin-left: -20px;
    padding-top: 10px;
  }
  .footer .txt-ba a {
    color: #666;
    margin: 0 10px;
  }
  .footer .tr {
    text-align: right;
  }
  .footer .icon-jc {
    padding-top: 8px;
    display: inline-block;
  }
  .footer .tl {
    margin-top: 0px;
  }
  .u-md-1-2, .u-md-12-24 {
    width: 50%;
  }
  .u-md-1-4, .u-md-6-24 {
    width: 25%;
  }
  .u-md-1-5 {
    width: 20%;
  }
  .u-md-1, .u-md-1-1, .u-md-1-12, .u-md-1-2, .u-md-1-24, .u-md-1-3, .u-md-1-4, .u-md-1-5, .u-md-1-6, .u-md-1-8, .u-md-10-24, .u-md-11-12, .u-md-11-24, .u-md-12-24, .u-md-13-24, .u-md-14-24, .u-md-15-24, .u-md-16-24, .u-md-17-24, .u-md-18-24, .u-md-19-24, .u-md-2-24, .u-md-2-3, .u-md-2-5, .u-md-20-24, .u-md-21-24, .u-md-22-24, .u-md-23-24, .u-md-24-24, .u-md-3-24, .u-md-3-4, .u-md-3-5, .u-md-3-8, .u-md-4-24, .u-md-4-5, .u-md-5-12, .u-md-5-24, .u-md-5-5, .u-md-5-6, .u-md-5-8, .u-md-6-24, .u-md-7-12, .u-md-7-24, .u-md-7-8, .u-md-8-24, .u-md-9-24 {
    display: inline-block;
    zoom: 1;
    letter-spacing: normal;
    word-spacing: normal;
    vertical-align: top;
    text-rendering: auto;
  }
  .step-content-title{
    margin-top: 0;
    margin-bottom: 15px;
    padding-bottom: 15px;
    padding-top: 15px;
    font-size: 18px;
    border-bottom: 1px solid #cad3ce;
    color: #719d79;
  }

  /deep/ .el-form-item__error  {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 0px;
    position: absolute;
    top: 100%;
    left: 0;
  }

  /deep/ .el-form-item {
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/zydj/LegalMain.vue